define('views/components/wallet_history/wallet_histories',['require','views/base/collection_view','views/components/wallet_history/wallet_history_list','text!templates/base/collection.html'],function(require){

    var BaseCollectionView = require('views/base/collection_view');
    var ListView = require('views/components/wallet_history/wallet_history_list');

    var temp = require("text!templates/base/collection.html");
    return BaseCollectionView.extend({
        template: _.template(temp),
        className: 'grid-container action-history-grid-container',

        onRender: function () {
            this.ListContainer.show(new ListView({
                collection: this.collection
            }));
        }
    });
});

